var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeUnique(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#EAD7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5599 26.5863V15.7021C18.5602 15.5073 18.6385 15.3205 18.7775 15.1828C18.9166 15.045 19.1051 14.9675 19.3018 14.9672H33.4347V12.8292C33.4347 12.6093 33.3465 12.3984 33.1895 12.2429C33.0325 12.0874 32.8196 12 32.5975 12H7.83715C7.72727 11.9998 7.61843 12.0212 7.51687 12.0627C7.41531 12.1042 7.32302 12.1652 7.24527 12.2421C7.16751 12.319 7.10583 12.4104 7.06375 12.5109C7.02166 12.6114 7 12.7192 7 12.828V25.1039C7.00062 28.5757 8.39352 31.905 10.8723 34.3596C13.3511 36.8143 16.7128 38.1931 20.2179 38.1928V38.1928C22.0013 38.1948 23.7666 37.8384 25.4069 37.145C23.3646 36.2193 21.6337 34.7321 20.4199 32.8603C19.2061 30.9886 18.5605 28.8109 18.5599 26.5863V26.5863Z",
    fill: "url(#paint0_linear_1366_17463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15.702C41.9997 15.5072 41.9214 15.3204 41.7823 15.1827C41.6432 15.0449 41.4547 14.9674 41.258 14.9671H33.4346V25.1038C33.4346 27.6694 32.6738 30.1786 31.2467 32.3197C29.8195 34.4608 27.7888 36.1394 25.4067 37.1473C26.9371 37.8405 28.6006 38.1979 30.2833 38.195C33.3911 38.1941 36.3713 36.9706 38.5685 34.7936C40.7657 32.6167 42 29.6645 42 26.5862V15.702Z",
    fill: "url(#paint1_linear_1366_17463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1366_17463",
    x1: 6.11292,
    y1: 36.9242,
    x2: 24.8946,
    y2: 13.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#210D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#361463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#581F85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1366_17463",
    x1: 31.1275,
    y1: 37.1415,
    x2: 42.6132,
    y2: 10.2021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC300"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeUnique);
export default __webpack_public_path__ + "static/media/icone_unique.0b64d3a782e100c83327887fb6006c28.svg";
export { ForwardRef as ReactComponent };